var _style, _defs, _g, _defs2, _defs3, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{clip-path:url(#SVGID_5_);}\r\n\t.st2{fill:#7ED4C9;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 110,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M106,31"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M-4,31"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Ice",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_1_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st2",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(14 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon",
    className: "st3",
    d: "M-6.3-13.8l0.1,5l-4.3,2.1l-0.1-4.7L-6.3-13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon-2",
    className: "st3",
    d: "M-2-6l-4.3,2.4L-10.6-6l4.3-2.2L-2-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_Copy",
    className: "st3",
    d: "M-11.3-6l-4.3,2.4L-19.9-6l4.3-2.2L-11.3-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon-3",
    className: "st3",
    d: "M-15.6-13.9l4.4,2.2l-0.1,4.8l-4.2-2.1L-15.6-13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon-4",
    className: "st3",
    d: "M-6.2,1.7l-4.4-2.2l0.1-4.8l4.2,2.1L-6.2,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon-5",
    className: "st3",
    d: "M-15.5,1.8l-0.1-5l4.3-2.1l0.1,4.7L-15.5,1.8z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.9,20.3h-2.1v-10h2.1V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.6,17c-0.1,1.1-0.5,1.9-1.2,2.5c-0.7,0.6-1.7,0.9-2.8,0.9c-1.3,0-2.3-0.4-3-1.3s-1.1-2-1.1-3.5V15 c0-1,0.2-1.8,0.5-2.5s0.8-1.3,1.4-1.7s1.4-0.6,2.2-0.6c1.1,0,2.1,0.3,2.8,0.9s1.1,1.5,1.2,2.6h-2.1c0-0.6-0.2-1.1-0.5-1.4 c-0.3-0.3-0.8-0.4-1.4-0.4c-0.7,0-1.2,0.2-1.5,0.7s-0.5,1.3-0.5,2.3v0.8c0,1.1,0.2,1.9,0.5,2.4c0.3,0.5,0.8,0.7,1.5,0.7 c0.6,0,1.1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.5-1.3H60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68,16H64v2.7h4.6v1.6H62v-10h6.7V12H64v2.4H68V16z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce);
export default __webpack_public_path__ + "static/media/ice.2bf189b71bf870f5d3f13dab35fe8b04.svg";
export { ForwardRef as ReactComponent };